import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const MinusCircleOutlinedSvg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4311_41358)">
      <path
        d="M16.9285 11.1428H7.0714C6.95355 11.1428 6.85712 11.2393 6.85712 11.3571V12.6428C6.85712 12.7607 6.95355 12.8571 7.0714 12.8571H16.9285C17.0464 12.8571
        17.1428 12.7607 17.1428 12.6428V11.3571C17.1428 11.2393 17.0464 11.1428 16.9285 11.1428Z"
        fill="currentColor"
      />
      <path
        d="M12 0C5.37321 0 0 5.37321 0 12C0 18.6268 5.37321 24 12 24C18.6268 24 24 18.6268 24 12C24 5.37321 18.6268 0 12 0ZM12 21.9643C6.49821 21.9643 2.03571
        17.5018 2.03571 12C2.03571 6.49821 6.49821 2.03571 12 2.03571C17.5018 2.03571 21.9643 6.49821 21.9643 12C21.9643 17.5018 17.5018 21.9643 12 21.9643Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_4311_41358">
        <rect width="24" height="24" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

const MinusCircleOutlined = (props: IIconProps) => <Icon component={MinusCircleOutlinedSvg} {...props} />;

export default MinusCircleOutlined;
